<template>
  <!-- 法人信息 -->
  <div class="Legal-info">
    <div class="Legal-content">
      <div class="Legal-top">
        <h1>法人信息</h1>
      </div>

      <div class="Collection-main">
        <el-form class="Form-style">
          <el-form-item class="Company-name" label="姓名">
            <el-input v-model="dataForm.legalPerson" placeholder="请输入准确的法人姓名"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="身份证件类型">
            <el-select v-model="dataForm.certificatesLegal" placeholder="请选择法人身份证件类型">
              <el-option v-for="item in certificatesLegalOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="Company-name" label="身份证件号码">
            <el-input v-model="dataForm.certificatesLegalNumber" placeholder="点击输入法人身份证件号码"></el-input>
          </el-form-item>

          <el-form-item class="Company-name" label="法人手机号">
            <el-input v-model="dataForm.legalPhone" placeholder="点击输入法人手机号码"></el-input>
          </el-form-item>

          <el-form-item class="Company-name Last-hang" label="身份证件">
            <!-- 法人证件正面 -->
            <wintac-upload class="Front" imgName="法人证件正面" :pid="dataForm.id" :state="2" env="user">
            </wintac-upload>
            <!-- 法人证件反面 -->
            <wintac-upload class="Front" :pid="dataForm.id" imgName="法人证件反面" :state="3" env="user">
            </wintac-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import { mapState } from 'vuex'
  export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
      return {
        dataForm: {
          legalPerson: '', //法人姓名
          certificatesLegal: 0, //法人证件类型 0 身份证
          certificatesLegalNumber: '', //法人证件号码
          legalPhone: '', //法人电话号码
          frontFileList: [], //证件正面
          reverseFileList: [], //证件反面
        },
        certificatesLegalOption: [
        {
          value: 0,
          label: '身份证'
        }]
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapState(['tianyanchaQueryData']),
      ...mapState(['supplierBasics'])
    },
    // 监控data中的数据变化
    watch: {
      'dataForm': {
        handler(value) {
          this.$store.commit('gasserLegaInfo', value)
        },
        deep: true
      },
      'tianyanchaQueryData': {
        handler(value) {
          this.dataForm.legalPerson = value.legalPerson
          this.dataForm.legalPhone = value.telephone
        },
        deep: true
      },
      'supplierBasics': {
        handler(value) {
          if (value.mechanismSupplier.legalPerson != undefined && value.mechanismSupplier.legalPhone != undefined) {
            this.dataForm = value.mechanismSupplier
          }
          this.dataForm.certificatesLegal = Number(this.dataForm.certificatesLegal)
        },
        deep: true
      }
    },
    // 方法集合
    methods: {
      changeFrontFile(e) {
        this.frontFileList = e
      },
      changeReverseFile(e) {
        this.reverseFileList = e
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style scoped lang="scss">
  /deep/ .container {
    margin-top: 5px;
  }

  /deep/ .Front {
    display: inline-flex;
    flex-direction: column;

    &::after {
      content: "证件正面";
      text-align: center;
    }
  }

  /deep/ .Reverse {
    display: inline-flex;
    flex-direction: column;

    &::after {
      content: "证件反面";
      text-align: center;
    }
  }

  .Legal-info {
    // width: 12.8rem;
    margin: 0 auto;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
    border-radius: 6px 6px 6px 6px;
    background-color: rgba(255, 255, 255, 1);
    margin: 15px auto;

    .Legal-content {
      padding: 30px;
    }

    .Legal-top {
      display: flex;
      justify-content: space-between;
    }

    .Form-style {
      padding-top: 15px;
    }

    .Form-style /deep/.el-input {
      width: 5rem;
    }

    .Form-style /deep/.el-input__inner {
      border: none;
      background: none;
      border-radius: 0 !important;
      padding-left: 0;
      font-size: 14px;
      font-family: PingFangSC-light;
    }

    .Form-style /deep/.el-form-item__label {
      font-size: 14px;
      border-radius: 0 !important;
      padding-right: 150px;
      font-family: PingFangSC-light;
      width: 5rem;
      text-align: left;
    }

    .Form-style /deep/.el-form-item {
      display: flex;
      border-bottom: 1.3px dashed rgba(242, 237, 237, 1);
    }
  }

  .Last-hang {
    border-bottom: none !important;
  }
</style>